// extracted by mini-css-extract-plugin
export var orderSummary = "_tz-0";
export var showMoreLessButton = "_tz-1";